export const typeMsg = (field: string, type: string) => {
  return `${field} يجب أن يتكون من ${type}`;
};

export const requiredMsg = (field: string) => {
  return `الرجاء ادخال ${field}`;
};

export const minLengthMsg = (field: string, min: number) => {
  return `${field} يجب أن يكون ${min} أحرف أو أكثر`;
};

export const minValueMsg = (field: string, min: number) => {
  return `${field} يجب أن يكون مساوياً لـ ${min} أو أكثر`;
};

export const gtMsg = (field: string, num: number) => {
  return `${field} يجب أن يكون أكبر من ${num}`;
};

export const ltMsg = (field: string, num: number) => {
  return `${field} يجب أن يكون أقل من ${num}`;
};

export const maxLengthMsg = (field: string, max: number) => {
  return `${field} يجب أن يكون أقل من ${max + 1} احرف`;
};

export const rangeLengthMsg = (field: string, min: number, max: number) => {
  return `${field} يجب أن يكون أكثر من ${min} حروف وأقل من ${max} حروف`;
}